import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-rdsap-band',
  templateUrl: './rdsap-band.component.html',
  // styleUrls: ['./rdsap-band.component.css']
})
export class RdsapBandComponent implements OnChanges {
  @Input() rating: number | null;
  @Input() ratingType: 'environmental-impact' | 'energy-efficiency' = 'energy-efficiency';
  @Input() type: 'input' | 'valueOnly' | 'chip-small' | 'chip-medium' | 'chip-large';

  band: string;
  className: string;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.rating) {
      this.updateBandAndClass();
    }
  }

  private updateBandAndClass(): void {
    if (this.rating == null) {
      this.band = ' - ';
      this.className = this.ratingType === 'environmental-impact' ? 'environmental-impact-unknown' : 'energy-efficiency-unknown';
    } else if (this.rating >= 92) {
      this.band = 'A ' + this.rating;
      this.className = this.ratingType == 'environmental-impact' ? 'environmental-impact-92-300' : 'energy-efficiency-92-300';
    }
    else if (this.rating >= 81 && this.rating <= 91) {
      this.band = 'B ' + this.rating;
      this.className = this.ratingType == 'environmental-impact' ? 'environmental-impact-81-91' : 'energy-efficiency-81-91';
    }
    else if (this.rating >= 69 && this.rating <= 80) {
      this.band = 'C ' + this.rating;
      this.className = this.ratingType == 'environmental-impact' ? 'environmental-impact-69-80' : 'energy-efficiency-69-80';
    }
    else if (this.rating >= 55 && this.rating <= 68) {
      this.band = 'D ' + this.rating;
      this.className = this.ratingType == 'environmental-impact' ? 'environmental-impact-55-68' : 'energy-efficiency-55-68';
    }
    else if (this.rating >= 39 && this.rating <= 54) {
      this.band = 'E ' + this.rating;
      this.className = this.ratingType == 'environmental-impact' ? 'environmental-impact-39-54' : 'energy-efficiency-39-54';
    }
    else if (this.rating >= 21 && this.rating <= 38) {
      this.band = 'F ' + this.rating;
      this.className = this.ratingType == 'environmental-impact' ? 'environmental-impact-21-38' : 'energy-efficiency-21-38';
    }
    else if (this.rating >= 1 && this.rating <= 20) {
      this.band = 'G ' + this.rating;
      this.className = this.ratingType == 'environmental-impact' ? 'environmental-impact-1-20' : 'energy-efficiency-1-20';
    }
  }
}
